import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
  TrackByFunction
} from '@angular/core'
import { Router } from '@angular/router'

import { HlmBadgeModule } from '@yoshu-lib/ui/ui-badge-helm/src'
import { HlmButtonModule } from '@yoshu-lib/ui/ui-button-helm/src'
import { HlmCardModule } from '@yoshu-lib/ui/ui-card-helm/src'
import { HlmIconModule } from '@yoshu-lib/ui/ui-icon-helm/src'
import { HlmInputModule } from '@yoshu-lib/ui/ui-input-helm/src'
import { HlmMenuModule } from '@yoshu-lib/ui/ui-menu-helm/src'
import { HlmTableModule } from '@yoshu-lib/ui/ui-table-helm/src'
import { HlmTabsModule } from '@yoshu-lib/ui/ui-tabs-helm/src'

import { NgIcon } from '@ng-icons/core'
import { BrnMenuTriggerDirective } from '@spartan-ng/brain/menu'
import { BrnTableModule } from '@spartan-ng/brain/table'

import { Protocol } from '@yoshu-lib/models/protocol.model'

@Component({
  imports: [
    CommonModule,
    HlmBadgeModule,
    HlmButtonModule,
    HlmTabsModule,
    NgIcon,
    HlmIconModule,
    HlmTableModule,
    BrnTableModule,
    HlmCardModule,
    HlmInputModule,
    HlmMenuModule,
    BrnMenuTriggerDirective
  ],
  selector: 'app-protocols-table',
  templateUrl: 'protocols-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProtocolsTableComponent {
  private readonly router = inject(Router)

  // inputs and outputs
  readonly protocolList = input<Protocol[]>([])
  readonly deleteEvent = output<string>()
  readonly viewEvent = output<string>()

  // table
  protected readonly _allDisplayedColumns = [
    'name',
    'description',
    'created_at',
    'updated_at',
    'actions'
  ]
  protected readonly _trackBy: TrackByFunction<Protocol> = (_: number, p: Protocol) => p.id

  // filter
  readonly filterText = signal('')
  readonly filteredProtocols = computed(() => {
    const query = this.filterText().toLowerCase()
    const protocols = this.protocolList()

    return protocols.filter((protocol) => {
      return (
        protocol.name.toLowerCase().includes(query) ||
        protocol.description.toLowerCase().includes(query)
      )
    })
  })

  viewProtocol(protocolId: string) {
    this.viewEvent.emit(protocolId)
  }

  handleDelete(protocolId: string) {
    this.deleteEvent.emit(protocolId)
  }

  onFilterInput(event: Event) {
    const { value } = event.target as HTMLInputElement
    this.filterText.set(value)
  }
}
